import { render, staticRenderFns } from "./Panache.vue?vue&type=template&id=62186e84&scoped=true&"
import script from "./Panache.vue?vue&type=script&lang=js&"
export * from "./Panache.vue?vue&type=script&lang=js&"
import style0 from "./Panache.vue?vue&type=style&index=0&id=62186e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62186e84",
  null
  
)

export default component.exports